import {Container} from 'components/atoms/Layout/Container';
import {MainGrid} from 'components/atoms/Layout/MainGrid';

import {P} from 'components/atoms/Text/P';
import {ConceptUsp} from 'components/molecules/ResidencePageComponents/ConceptUsp';
import {Margin, ParagraphSize, SITE, HeadlineLevel} from 'features/ui/enums';
import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import {ConceptType} from 'features/search/filters/enums';
import {getCurrentSite} from 'features/services/utils/env-helper';
import {getFormattedMessage} from 'features/services/utils/language-helper';


import './_concept.scss';
import {UspModel} from "features/template/viewModels/ResidenceStage";
import {UserAgent} from "@atoms/UserAgent";
import {Headline} from '@atoms/Text/Headline';

interface Props {
    concept: string;
    uspModel: UspModel;
}

export const Concept: React.FunctionComponent<Props> = ({concept, uspModel}) => {
    return (
        <section 
            className={concept === ConceptType.PREMIUM ?
                        "residence-concept-usp dark-bg" :
                        "residence-concept-usp"
                    } 
        >
            <Container>
                <Headline level={HeadlineLevel.H2} center margin={Margin.S}>
                    {concept === ConceptType.PREMIUM ?
                        getFormattedMessage('jm.components.StagePage.conceptPremium') :
                        getFormattedMessage('jm.components.StagePage.conceptSmartHousing')
                    }
                </Headline>

                <Container narrow className="residence-concept-usp__text">
                    {getCurrentSite() !== SITE.FI &&
                        <UserAgent computer>
                            <P size={ParagraphSize.S}><FormattedMessage id='jm.components.StagePage.conceptTag' /></P>
                        </UserAgent>
                    }
                    {uspModel.intro && <P>{uspModel.intro}</P>}
                </Container>

                <MainGrid fullwidth noGap>
                    <ConceptUsp
                        headline={uspModel.uspOneTitle}
                        text={uspModel.uspOne}
                    />
                    <ConceptUsp
                        headline={uspModel.uspTwoTitle}
                        text={uspModel.uspTwo}
                    />
                    <ConceptUsp
                        headline={uspModel.uspThreeTitle}
                        text={uspModel.uspThree}
                    />
                </MainGrid>
            </Container>
        </section>
    )
};
